/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, getProp, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Button, ButtonProps} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {Store} from '@gongxigames/framework/core/fragments/store';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';

export type TurboBtnProps = CanBeSignals<{
    currentLevel: ReelsSpeedLevel;
}> & Omit<ButtonProps, 'name'>;

const LEVEL_MAPPING: Record<ReelsSpeedLevel, string> = {
    [ReelsSpeedLevel.normal]: 'turbo_btn_off',
    [ReelsSpeedLevel.turbo_1]: 'quick_btn_on',
    [ReelsSpeedLevel.turbo_2]: 'turbo_btn_on',
};

export const $TurboBtn: FC<TurboBtnProps> = (props) => {
    const name = Store.computed(() => {
        const level = getProp(props.currentLevel);

        return LEVEL_MAPPING[level];
    });

    return <$Button
        {...props}
        name={name}
    />;
};